<template>
  <div class="row m-b-lg m-t-lg wrapper">
    <modal-form modal-id="add-backorder">
      <div slot="title">Backorder Domains</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12">
            <textarea name="domains" class="form-control" rows="10" placeholder="Domains (1 per line)" v-model="backorderDomains"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 m-t-xs">
            <button class="btn btn-sm btn-primary" @click="backorder">Order</button>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="col-md-12">
      <h3 class="col-lg-6"><e-txt :text="order.name" @input="updateOrder($event, 'name')" close-on-save="true"></e-txt></h3>
      <div class="col-lg-6">
        <button class="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target="#add-backorder">Backorder Domains</button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row" v-if="order.client">
        <div class="col-md-2">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Client</td>
              <td>
                <v-select v-if="user.admin" :options="filters.clients" label="name" index="id" v-model="order.client.id" @input="updateOrder($event, 'client')">
                </v-select>
                <span v-else><strong>{{ order.client.name }}</strong></span>
              </td>
            </tr>
            <tr>
              <td>Group</td>
              <td>
                <v-select v-if="user.admin && filters.groupsByClient[order.client.id]" :options="filters.groupsByClient[order.client.id]" label="name" index="id" :value="order.group ? order.group.id : null" @input="updateOrder($event, 'group')">
                </v-select>
                <span v-else><strong>{{ order.client.name }}</strong></span>
              </td>
            </tr>
            <tr>
              <td>Type</td>
              <td><strong>{{ order.type || 'pbn' }}</strong></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-2">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Added</td>
              <td>
                <strong>{{ $moment(order.added.date).format('DD.MM.YYYY') }}</strong>
              </td>
            </tr>
            <tr>
              <td>Size:</td>
              <td>
                <e-txt :text="order.size" type="number" @input="updateOrder($event, 'size')" close-on-save="true"></e-txt>
              </td>
            </tr>
            <tr>
              <td>Domains:</td>
              <td>
                <strong>{{ order.domainCount }}/{{ order.size }}</strong>
              </td>
            </tr>
            <tr>
              <td>Status:</td>
              <td>
                <e-txt :text="order.status" type="select" @input="updateOrder($event, 'status')" close-on-save="true" :options="['open','completed']"></e-txt>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-2">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Target Country</td>
              <td>
                <strong>{{ order.targetCountry || '/' }}</strong>
              </td>
            </tr>
            <tr>
              <td>Target Topic</td>
              <td>
                <strong>{{ order.targetTopic || '/' }}</strong>
              </td>
            </tr>
            <tr>
              <td>Target Site</td>
              <td>
                <strong>/</strong>
              </td>
            </tr>
            <tr>
              <td>Hosting</td>
              <td>
                <strong v-if="order.hosting">{{ order.hosting.name }}</strong>
                <strong v-else>/</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <e-txt type="textarea" :text="order.description" @input="updateOrder($event, 'description')"></e-txt>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Domain Supplier</td>
              <td>
                <e-txt :text="order.domainSupplier" type="select" :options="['client', 'in-house']" @input="updateOrder($event, 'domainSupplier')"></e-txt>
              </td>
            </tr>
            <tr v-if="order.domainSupplier === 'in-house'">
              <td colspan="2">
                <v-select
                  placeholder="Registrars"
                  :value="order.domainRegistrars[0] && order.domainRegistrars[0].id ? order.domainRegistrars.map(o => o.id) : ''"
                  :options="filters.registrars"
                  label="name" index="id" multiple
                  @input="updateOrder($event, 'domainRegistrars')"
                ></v-select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import EditText from '../../../Helpers/Form/EditText'
import { ORDER_SET } from '../../../../store/mutation-types'
import Form from '../../../Helpers/Modal/Form'

export default {
  data () {
    return {
      backorderDomains: '',
      statuses: [
        'open', 'completed'
      ]
    }
  },
  components: {
    eTxt: EditText,
    modalForm: Form
  },
  computed: {
    ...mapGetters({
      filters: 'getFilters',
      user: 'getUser',
      order: 'getOrder'
    })
  },
  methods: {
    updateOrder (e, prop) {
      let data = {}
      data[prop] = e
      axios.patch('/pbn/order/' + this.$route.params.orderId, data)
        .then(r => {
          this.$toastr.success('Updated ' + prop, 'High five!')
          this.$store.commit(ORDER_SET, r.data.order)
        })
        .catch()
    },
    backorder () {
      axios.post(`/pbn/order/${this.order.id}/backorder`, {
        domains: this.backorderDomains
      })
        .then(r => {
          $('#add-backorder').modal('hide')
          this.backorderDomains = ''
          this.$store.commit(ORDER_SET, r.data.order)
          this.$toastr.success('Domain backorders added', 'Success')
        })
        .catch(e => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Order/Header.vue